import { z } from "zod";

const loginSchema = z.object({
  email: z.string().min(1, "Please enter your email.").email("Please enter a valid email address."),
  password: z.string().min(3, "Please enter your password."),
});

export default loginSchema;
